import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function Faq() {
  const faqs = [{
    q: 'Do you offer emergency auto glass near me?',
    a: "Kosin's Glass serves Howell, Ann Arbor, Novi and surrounding Southeast Michigan communities. Call or request an urgent quote and the team will confirm today's availability for your vehicle and glass type."
  }, {
    q: 'Can I get same-day windshield replacement?',
    a: 'Same-day openings may be available depending on your vehicle, glass availability, insurance details and the schedule. Call 517-545-7772 to check the fastest available option.'
  }, {
    q: 'My windshield is cracked. Is it safe to drive?',
    a: "If the crack blocks your view, is spreading, is near the windshield edge, or makes the vehicle feel unsafe, do not continue driving. Call Kosin's Glass for guidance on the safest next step."
  }, {
    q: 'Can a broken windshield be repaired today?',
    a: "Small chips may be repairable if they are contained, away from the driver's line of sight and away from the windshield edge. Cracks are generally not repairable and usually require replacement."
  }, {
    q: 'Do you replace shattered side windows and rear windows?',
    a: "Yes. Kosin's Glass replaces side windows, driver and passenger door glass, power window glass, quarter glass and rear vehicle glass."
  }, {
    q: "Can Kosin's Glass help with insurance?",
    a: "Yes. Kosin's Glass works with most insurance companies and can help with quote details, claim coordination and scheduling."
  }, {
    q: 'Will I need ADAS calibration after emergency windshield replacement?',
    a: "If your vehicle has a forward-facing camera or driver-assistance sensors near the windshield, calibration may be required after replacement. Kosin's Glass offers on-site ADAS calibration."
  }, {
    q: 'What information should I have ready when I call?',
    a: 'Have your vehicle year, make, model, which glass is damaged, a photo if possible, insurance information and your best callback number ready.'
  }, {
    q: 'Do you repair truck, van, fleet or semi-truck glass?',
    a: "Yes. Kosin's Glass handles auto glass for cars, trucks, vans, fleet vehicles and semi trucks. Availability depends on the vehicle and glass needed."
  }, {
    q: 'Are you open on weekends?',
    a: "Kosin's Glass is open Monday through Friday from 8:00 a.m. to 5:00 p.m. and Saturday from 9:00 a.m. to 3:00 p.m. Sunday is closed."
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <div className="text-center mb-12" data-id="element-65">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-66">
            <span className="text-brand-red" data-id="element-67">Emergency Auto Glass</span>{' '}
            Questions
          </h2>
        </div>

        <div className="space-y-3" data-id="element-68">
          {faqs.map((faq, i) => <FaqItem key={i} question={faq.q} answer={faq.a} data-id="element-69" />)}
        </div>
      </div>
    </section>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border rounded-xl overflow-hidden bg-white transition-colors ${isOpen ? 'border-brand-red/40 shadow-sm' : 'border-slate-200'}`} data-id="element-70">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 sm:px-6 py-4 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red/40 transition-colors gap-4" aria-expanded={isOpen} data-id="element-71">
        <span className="font-bold text-slate-900" data-id="element-72">{question}</span>
        <ChevronDown className={`w-5 h-5 shrink-0 transition-all duration-200 ${isOpen ? 'rotate-180 text-brand-red' : 'text-slate-400'}`} data-id="element-73" />
      </button>
      <div className={`px-5 sm:px-6 overflow-hidden transition-all duration-200 ease-in-out ${isOpen ? 'max-h-96 pb-5 pt-1' : 'max-h-0 py-0'}`} data-id="element-74">
        <p className="text-slate-600 leading-relaxed" data-id="element-75">{answer}</p>
      </div>
    </div>;
}